module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB4AAAAYCAYAAADtaU2/AAAAAXNSR0IArs4c6QAAAERlWElmTU0AKgAAAAgAAYdpAAQAAAABAAAAGgAAAAAAA6ABAAMAAAABAAEAAKACAAQAAAABAAAAHqADAAQAAAABAAAAGAAAAABFAcKlAAAAU0lEQVRIDWOcOXPmf4YBAEwDYCfYypFn8UCF9Ki9oyFAuxBgRDeaViVZeno6il0jrwAZMB+jR/EofzQEhn4IoJQm2LxDbkmGXlKhmz1g+XjkWQwAqogK4B9tCnUAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icon-funnel.png
// module id = 5fJ7
// module chunks = 1